import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        // Persist the admin token in localStorage too (cookies-blocked browsers fallback)
        if (res.data?.session_token) {
          try { localStorage.setItem('balmart_admin_token', res.data.session_token); } catch {}
        }
        setUser(res.data);
        navigate('/dashboard', { state: { user: res.data }, replace: true });
      } catch (err) {
        console.error('Auth exchange failed:', err);
        navigate('/admin', { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return null;
}
